
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexaYimuhc9uN4LbrlkB_O21m2VAegQrTDQJs_64DoKXjcMeta } from "/tmp/tmpkyj7iuwo/pages/index.vue?macro=true";
import { default as indexrX764OvGM1hh5w_45yrlrKi2ct98DHIrshlMbALIOuJJsMeta } from "/tmp/tmpkyj7iuwo/pages/[area]/index.vue?macro=true";
import { default as indexyMlQkLxLmyHUXP18LiXsPVtqOuhbxF7kEsUtufRUW_45QMeta } from "/tmp/tmpkyj7iuwo/pages/okinawa/index.vue?macro=true";
import { default as indexBIoPWatNF55hmyiiZmkWLW5s_zVMjD7xY1O7PyaJkkkMeta } from "/tmp/tmpkyj7iuwo/pages/ranking/index.vue?macro=true";
import { default as indexRJyWleY6PkdLUBFWGMQeASwBv2ySN_45vVoIg2uhK0_EAMeta } from "/tmp/tmpkyj7iuwo/pages/okinawa/[id]/index.vue?macro=true";
import { default as indexdtROR1mD_45VuVlrTag0w1OhXz_zc3LpWhIOZoP2HUhbYMeta } from "/tmp/tmpkyj7iuwo/pages/[area]/[pref]/index.vue?macro=true";
import { default as indexK3IIXurgU_45r9nc85zK_F3eEH_WBwXBvh5qccFquaVZEMeta } from "/tmp/tmpkyj7iuwo/pages/ranking/[area]/index.vue?macro=true";
import { default as indexyu7MiMHft_45K1o3qitVbmc2ku5hEXHU_45dkBGLd9sHsssMeta } from "/tmp/tmpkyj7iuwo/pages/[area]/[pref]/[id]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmpkyj7iuwo/pages/index.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/tmp/tmpkyj7iuwo/pages/[area]/index.vue")
  },
  {
    name: "okinawa",
    path: "/okinawa",
    component: () => import("/tmp/tmpkyj7iuwo/pages/okinawa/index.vue")
  },
  {
    name: "ranking",
    path: "/ranking",
    component: () => import("/tmp/tmpkyj7iuwo/pages/ranking/index.vue")
  },
  {
    name: "okinawa-id",
    path: "/okinawa/:id()",
    component: () => import("/tmp/tmpkyj7iuwo/pages/okinawa/[id]/index.vue")
  },
  {
    name: "area-pref",
    path: "/:area()/:pref()",
    component: () => import("/tmp/tmpkyj7iuwo/pages/[area]/[pref]/index.vue")
  },
  {
    name: "ranking-area",
    path: "/ranking/:area()",
    component: () => import("/tmp/tmpkyj7iuwo/pages/ranking/[area]/index.vue")
  },
  {
    name: "area-pref-id",
    path: "/:area()/:pref()/:id()",
    component: () => import("/tmp/tmpkyj7iuwo/pages/[area]/[pref]/[id]/index.vue")
  }
]